import i18next from "@companion-core/shared/app/I18n";

const BASE_TITLE = "common.head.title";
let title;

/** Routes where RequestDetailLayout / RequestDetailBoxLayout set document.title. */
export function isRequestDetailDocumentTitleManaged(pathname: string): boolean {
  return /^\/my-requests\/[^/]+\/(details|editor)(\/|$)/.test(pathname);
}

i18next.on("languageChanged init", () => {
  updateDocumentTitle(); // To be sure that the title is updated when i18n instance has finished to load locolize files
});

export function updateDocumentTitle(slugPage = "") {
  const translationKey = slugPage.slice(1).split("/")[0];
  const titleKey =
    i18next.exists(`${BASE_TITLE}.${translationKey}`) &&
    typeof i18next.t(`${BASE_TITLE}.${translationKey}`, { returnObjects: true }) !== "object"
      ? `${BASE_TITLE}.${translationKey}`
      : `${BASE_TITLE}.default`;
  title = i18next.t(titleKey);
  // Update document title
  document.title = title;
}
